export default {
  setHomeData: (state, data) => {
    state.homeData = data;
  },
  setSuggestKeywords: (state, data) => {
    state.suggestKeywords = data;
  },
};
